import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Hooks
import { useAppSelector } from "src/App/hooks";
// Common Components
import { TextInput, Button } from "src/Components";
import SelectableButtons from "src/Components/Dropdown/SelectableButtons";
// Types
import { IMinProfit } from "src/Interfaces/coveredCall";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
// Requests
import {
  getPairType,
  getMinProfitOffset,
  setMinProfitOffset,
} from "src/Requests/coveredCall";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  onClose: () => void;
}
const ExpectedReturnModal: React.FC<IProps> = (props) => {
  // store
  const riskProfiles = useAppSelector(
    (store) => store.coveredCall.riskProfiles,
  );
  // local store
  const [config, setConfig] = React.useState<IMinProfit>({
    "1": 0,
    "2": 0,
    "3": 0,
    "4": 0,
    "5": 0,
    "6": 0,
    "7": 0,
    "8": 0,
  });
  const [pairType, setPairType] = React.useState<DropdownItem[]>([]);
  const [riskProfileId, setRiskProfileIds] = React.useState<string>(
    riskProfiles[0]?.id?.toString() ?? 0,
  );

  React.useEffect(() => {
    getPairType()
      .then((res) => {
        setPairType(res);
      })
      .catch(packetErrorHandler);
  }, []);

  React.useEffect(() => {
    getMinProfitOffset(riskProfileId)
      .then((res) => {
        const newConfig = Object.assign({}, ...res);
        setConfig(newConfig);
      })
      .catch(packetErrorHandler);
  }, [riskProfileId]);

  const changeHandler = (name: string, value: any) => {
    setConfig((prev) => ({
      ...prev,
      [name as `${number}`]: value ?? "",
    }));
  };

  const setConfigHandler = () => {
    const newConfig = Object.entries(config).map(([key, value]) => ({
      [key]: value,
    }));
    setMinProfitOffset(riskProfileId, newConfig)
      .then((resp) => {
        toast.success(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => {
        props.onClose();
      });
  };

  return (
    <div className="w-full flex flex-col justify-center items-center gap-3">
      <SelectableButtons
        label="ریسک پروفایل"
        name="riskProfileId"
        onChange={(_: string, value: string) => setRiskProfileIds(value)}
        options={riskProfiles}
        value={riskProfileId}
        hideSelectAll
      />
      {pairType.map((item) => {
        const key = item.id.toString() as `${number}`;
        const value = config[key];
        return (
          <div key={key} className="flex w-full items-center">
            <span className="text-sm text-gray-500 w-64">% {item.name}</span>
            <TextInput
              label=""
              name={item.id.toString()}
              onChange={changeHandler}
              value={String(value) ?? ""}
              kind="negativeDecimalNumbers"
              extraLabel
            />
          </div>
        );
      })}

      <div className="w-[200px] mt-7">
        <Button onClick={setConfigHandler} text="ثبت" variant="contained" />
      </div>
    </div>
  );
};

export default ExpectedReturnModal;
